var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconGlassDamage(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.58579 6H4.45912L4.02735 16.3623L4.80355 16.7073C6.72138 17.5596 8.79671 18 10.8954 18H13.1045C15.2034 18 17.2789 17.5595 19.1968 16.7071L19.9725 16.3623L19.5407 6H9.41422L11.2071 7.79289C11.4275 8.01328 11.5325 8.32382 11.4912 8.63273C11.4498 8.94165 11.2668 9.21361 10.9961 9.36824L8.47968 10.8062L9.30001 11.9C9.63138 12.3418 9.54183 12.9686 9.10001 13.3C8.65818 13.6314 8.03138 13.5418 7.70001 13.1L6.20001 11.1C6.02791 10.8705 5.96263 10.5782 6.02076 10.2973C6.07889 10.0165 6.25483 9.77407 6.50387 9.63176L8.86712 8.28133L6.58579 6ZM7.00018 4H19.5407C20.6129 4 21.4943 4.84549 21.539 5.91674L21.9707 16.2791C22.0049 17.099 21.5347 17.8566 20.7848 18.1899L20.0091 18.5347C17.8355 19.5008 15.4832 20 13.1045 20H10.8954C8.51689 20 6.16484 19.5009 3.9913 18.5349L3.21511 18.1899C2.46515 17.8566 1.99492 17.099 2.02909 16.279L2.46085 5.91674C2.50549 4.84548 3.38694 4 4.45912 4H6.99983C6.99995 4 7.00006 4 7.00018 4Z", fill: color }))));
}
//# sourceMappingURL=icon.glass-damage.component.js.map